import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LazyApp = () => Promise<{ default: React.ComponentType<React.PropsWithChildren<any>> }>;

interface AppRegistry {
  [key: string]: LazyApp;
}

const appRegistry: AppRegistry = {
  Summary: () => import('./apps/SummaryApp'),
  MfaSudoChallengeFlow: () => import('./apps/MfaSudoChallengeFlowApp'),
  MfaSmsSetupFlow: () => import('./apps/MfaSmsSetupFlowApp'),
  FourOhOneKLead: () => import('./apps/FourOhOneKLeadApp'),
  FourOhOneKDashboard: () => import('./apps/FourOhOneKDashboardApp'),
  IraConversionFlow: () => import('./apps/IraConversionFlowApp'),
  Clients: () => import('./apps/ClientsApp'),
  AddAccounts: () => import('./apps/AddAccountsApp'),
  AdvisorMfaSetupTotp: () => import('./apps/AdvisorMfaSetupTotpApp'),
  EtfPortfolios: () => import('./apps/EtfPortfoliosApp'),
  GoldmanSachsTaxSmartBondAdviceApp: () => import('./apps/GoldmanSachsTaxSmartBondAdviceApp'),
  FirmIntegrations: () => import('./apps/FirmIntegrationsApp'),
  GoalCreationFlow: () => import('./apps/GoalCreationFlowApp'),
  Solo401kConversion: () => import('./apps/Solo401kConversionApp'),
  Solo401kEnvelopes: () => import('./apps/Solo401kEnvelopesApp'),
  Institutional: () => import('./apps/InstitutionalApp'),
  PortfoliosApp: () => import('./apps/PortfoliosApp'),
  SidebarNav: () => import('./apps/SidebarNavApp'),
  ClientTours: () => import('./apps/ClientToursApp'),
  HouseholdBalanceApp: () => import('./apps/HouseholdBalanceApp'),
  EditRebalanceSettingsApp: () => import('./apps/EditRebalanceSettingsApp'),
  WaitForFundLineupBanner: () => import('./apps/WaitForFundLineupBannerApp'),
  RebalancingLevelLabelApp: () => import('./apps/RebalancingLevelLabelApp'),
  PortfolioStrategySelectionApp: () => import('./apps/PortfolioStrategySelectionApp'),
  RebalanceNowApp: () => import('./apps/RebalanceNowApp'),
  InProgressErrorPageApp: () => import('./apps/InProgressErrorPageApp'),
  NotificationBannerApp: () => import('./apps/NotificationBannerApp'),
  RequestForProposalsFlow: () => import('./apps/RequestForProposalsFlowApp'),
  HouseholdSettingsPortfolioControlsApp: () => import('./apps/HouseholdSettingsPortfolioControlsApp'),
};

const retry = (fn: LazyApp, retriesLeft = 5, interval = 1000) => {
  return new Promise<{ default: React.ComponentType }>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: Error) => {
        if (retriesLeft === 0) {
          reject(error);
          return;
        }

        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

const getApp = (name: string) => React.lazy(() => retry(appRegistry[name]));

export default {
  getApp,
};
